module.exports = __webpack_public_path__ + "static/img/11.52cf71d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/4/zh/11.png
// module id = FuFu
// module chunks = 0